import PropTypes from 'prop-types';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import {
  DIRECTIONS,
  useDirection,
  useProperty,
  useSiteContext,
  useTranslation,
} from '@eti/providers';
import { css, etiColors, mediaQueries, resetButtonStyle } from '@eti/styles';
import { LANDING } from '../utils/constants';
import Faq from '../../order-details/components/common/Faq';
import PageSection from '../../order-details/components/common/PageSection';
import { isWhiteLabel } from '../../my-bookings/utils/utils';
import Call from './Call';

const backButtonStyles = css`
  ${resetButtonStyle}; /* stylelint-disable-next-line */
  color: ${etiColors.info.solid};
  font-size: 0.875rem;
  position: relative;
  top: 10px;

  & > svg {
    vertical-align: -1px;
  }

  @media ${mediaQueries.large.up} {
    top: 15px;
  }
`;

const contactSectionWrapperStyles = css`
  display: flex;
  flex-direction: column;
  gap: 24px 32px;

  & > div {
    flex: 1;
  }

  @media ${mediaQueries.large.up} {
    flex-direction: row;
  }
`;

const supportNoteStyles = css`
  font-size: 0.75rem;
  padding-bottom: 16px;
`;

const PreBooking = ({ setPageStatus }) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { direction } = useDirection();
  const { brand } = useSiteContext();

  const Caret = direction === DIRECTIONS.LTR ? CaretLeft : CaretRight;
  const isFaqEnabled = p('ContactUs.FAQ.Enabled');
  const isWhiteLabelBrand = isWhiteLabel(brand.code, p('MyBookingsWelcomePage.WhiteLabelBrands'));

  const onBackButtonClick = () => {
    setPageStatus(LANDING);
  };

  return (
    <>
      <button
        className={backButtonStyles}
        data-testid="back-button"
        onClick={onBackButtonClick}
        type="button"
      >
        <Caret color={etiColors.info.solid} size={12} weight="bold" />
        {t('Button.Text.Back')}
      </button>
      {isFaqEnabled && !isWhiteLabelBrand && (
        <PageSection heading={{ title: t('ContactUs.FAQ.Header') }}>
          <Faq
            buttonLink={t('ContactUs.FAQ.ButtonLink')}
            buttonText={t('ContactUs.FAQ.ButtonLabel')}
            maxQuestionsCount={p('ContactUs.FAQ.MaxNumberOfQuestions')}
            numberOfColumns={1}
            tag={p('ContactUs.FAQ.WithoutOrderTag')}
            testIdPrefix="contact-us"
          />
        </PageSection>
      )}
      <PageSection heading={{ title: t('ContactUs.ContactSection.Title') }}>
        <div className={supportNoteStyles}>{t('ContactUs.ContactMethods.SupportNote')}</div>
        <div className={contactSectionWrapperStyles} data-testid="pre-booking-contact-section">
          <div>
            <Call />
          </div>
        </div>
      </PageSection>
    </>
  );
};

PreBooking.propTypes = {
  setPageStatus: PropTypes.func,
};

export default PreBooking;
